import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ALLOWED_DOCUMENT_TYPES_X_STATES_QUERY } from '../../../queries';
import RefineAuthorizationContainer from './RefineAuthorizationContainer';
import ListBrowser, { getListBrowserStore } from '@ts-private/list-browser';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useMemo } from 'react';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const refineAuthorizationStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'documentTypeName',
      caption: 'Authorization.DocumentType',
      type: 'text'
    },
    {
      name: 'documentStateName',
      caption: 'Authorization.State',
      type: 'text'
    },
    {
      name: 'userGroups',
      caption: 'Authorization.UserGroup',
      type: 'text',
      isClient: true
    }
  ],
  orderByFields: [
    {
      caption: 'Authorization.DocumentType',
      value: 'DocumentTypeName'
    },
    {
      caption: 'Authorization.State',
      value: 'DocumentStateName'
    }
  ],
  pager: {
    orderBy: 'DocumentTypeName',
    direction: 'asc'
  }
});

const RefineAuthorizationListBrowser = ({ authorizationId, onSaveFnChanged, onChangedTitle }) => {
  const stateRef = useRef({});

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: ALLOWED_DOCUMENT_TYPES_X_STATES_QUERY,
        name: 'allowedDocumentTypesXStates',
        variables: { authorizationId }
      }
    }),
    [authorizationId]
  );

  const listContainer = useCallback(
    () => (
      <RefineAuthorizationContainer
        onSaveFnChanged={onSaveFnChanged}
        onChangedTitle={onChangedTitle}
        stateRef={stateRef}
        authorizationId={authorizationId}
      />
    ),
    [authorizationId, onChangedTitle, onSaveFnChanged]
  );

  return (
    <Card icon={ListAltIcon}>
      <ListBrowser name='refine-authorization-browser' store={refineAuthorizationStore} ItemsComponent={listContainer} />
      <ApolloFetchingComponent store={refineAuthorizationStore} options={fetchingOptions} />
    </Card>
  );
};

RefineAuthorizationListBrowser.propTypes = {
  authorizationId: PropTypes.number.isRequired,
  onSaveFnChanged: PropTypes.func.isRequired,
  onChangedTitle: PropTypes.func.isRequired
};

export default RefineAuthorizationListBrowser;
